export enum RoutePrefix {
  Static = '',
  ContactUs = 'contact-us',
  ProductCatalogList='product-catalog-list',
  Products = 'product',
  Register = 'register',
  Chat = 'chat',
  Order = 'order',
  User = 'user',
  CreditCards = 'credit-card',
  TrackAndTrace = 'track-and-trace',
  Home = 'home',
  MyHome = 'myhome',
  PackageInsert = 'package-insert',
  nfm = 'nfm',
  NFM = 'NFM',
  help = "major-help",
  Amazon = 'major-amazon'
  //MySubscription = 'my-subscription'
}

export const ContactUsRoutes = {
  ContactUsThankYou: RoutePrefix.ContactUs + '/thank-you'
};

export const PaymentConfirmationRoutes = {
  PayMyInvoicePaymentConfirmation: RoutePrefix.Order + '/payment-confirmation'
};

export enum OktaRoutes {
  ForgotPassword = 'forgot-password',
  ResetPassword = 'reset-password',
  ResetPwd = 'reset_password',
  ChangePassword = 'change-password',
  UpdateSecurityQuestion = 'security-question/update',
  AnswerSecurityQuestion = 'security-question/answer',
  Register = 'welcome',
  ActivateUser = 'activate-user',
  EmailSent = 'email-sent',
  VerifyToken = 'verify-token',
  PasswordExpired = 'expired-password'
}

export const ProductRoutes = {
  BasicSearch: RoutePrefix.Products + '/search',
  AdvanceSearch: RoutePrefix.Products + '/advance-search',
  Detail: RoutePrefix.Products + '/details/',
  Substitutes: RoutePrefix.Products + '/substitutes',
  ProductHistory: RoutePrefix.Products + '/history',
  ProductReturn: RoutePrefix.Products + '/return',
  StoreLocation: RoutePrefix.Products + '/store-location',
  ProductCatalog: RoutePrefix.Products + '/catalog',
  ProductCatalogList: RoutePrefix.Products + '/catalog-list',
  Favorites: RoutePrefix.Products + '/favorites',
  PayInvoices: RoutePrefix.Products + '/payinvoice',
  WatchList: RoutePrefix.Products + '/watchlist',
  Dispill: RoutePrefix.Products + '/search/dispill',
  Promotions: RoutePrefix.Products + '/promotions',
  Categories: RoutePrefix.Products + '/categories',
  Category_Detail: RoutePrefix.Products + '/categories/details/',
  Promotions_Detail: RoutePrefix.Products + '/promotions/details/',
  Subscription: RoutePrefix.Products + '/subscription/subscribed-items',
  Subscribe_Save: RoutePrefix.Products + '/subscription/subscribe-save',
  Product_Search: RoutePrefix.Products + '/product-catalog-search'
};

export const ChatRoutes = {
  StartChat: RoutePrefix.Chat + '/parmed/start'
};

export const OrderRoutes = {
  ShoppingCart: RoutePrefix.Order + '/shopping-cart',
  QuickOrder: RoutePrefix.Order + '/quick-order',
  OrderHistory: RoutePrefix.Order + '/history',
  CsosOrderHistory: RoutePrefix.Order + '/csos-order/history',
  OrderReview: RoutePrefix.Order + '/review',
  PaymentOptions: RoutePrefix.Order + '/payment-options',
  OrderSummary: RoutePrefix.Order + '/summary',
  OrderDetail: RoutePrefix.Order + '/detail',
  PayInvoice: RoutePrefix.Order + '/payinvoice'
};

export const UserRoutes = {
  ChangeAccount: RoutePrefix.User + '/change-account',
  WebAccountSettings: RoutePrefix.User + '/web-account-settings'
};

export const AEMRoutes = {
  Shop: 'shop',
  AboutUs: 'about-us',
  MyAccount: 'myaccount',
  MyAccountHarvard: 'myaccount-harvard',
  Help: 'help',
  ProductServices: 'product-services',
  MajorProductServices: 'major-product-services',
  MajorAboutUS: 'major-about-us',
  Legal: 'legal',
  MajorLegal: 'majorLegal',
  Privacy: 'privacy-policy',
  MajorPrivacy: 'majorPrivacy',
  Employment: 'employment-opportunities',
  ReturnConfirmation: 'return-and-confirmation',
  ReturnLanding: 'return-landing',
  CSOSHelp: 'csos-help',
  SDS: 'sds',
  EMED_BINAX_NOW: 'emedbinaxNOW',
  CustomerForms: 'customer-forms',
  DSCSA: 'dscsa',
  SubscriptionsHelp: 'subscriptions-help',
  Major: {
    Welcome: 'major-welcome',
    NewAccount: 'major-new-account',
    AboutUs: 'major-about-us',
    News :'major-news',
    Help:'major-help',
    ProductCatlog:'product-catlog',
    ProductCatalogList:'product-catalog-list'
  },
  Parmed: {
    Welcome: 'welcome',
    NewAccount: 'new-account',
    AboutUs: 'about-us'
  },
  Mobile: {
    Legal: 'mobile-legal',
    MajorLegal: 'mobile-major-legal',
    Privacy: 'mobile-privacy-policy',
    MajorPrivacy: 'mobile-major-privacy'
  }
};

export const TrackAndTraceRoutes = {
  SearchTransactionData: RoutePrefix.TrackAndTrace + '/search-transaction-data',
  DscsaTransactionData: RoutePrefix.TrackAndTrace + '/dscsa-transaction-data',
  DscsaReporting: RoutePrefix.TrackAndTrace + '/dscsa-reporting'
};